import HttpClient from "../client/httpclient";
import PaginatedData from "../client/PaginatedData";
import { paginatedContent } from "../paginated-content";
import 'regenerator-runtime/runtime';

document.addEventListener("DOMContentLoaded", function () {
    var selectElement = document.getElementById('multiple-list');
    var tabsContainer = document.getElementById('tabs-container-for-select');
    if (selectElement !== null) {


        // Create tabs for each option
        if (selectElement && selectElement.options) {
            Array.from(selectElement.options).forEach(function (option) {
                var tabHeader = document.createElement('div');
                tabHeader.className = 'tab-header-for-select';
                tabHeader.textContent = option.textContent;
                tabHeader.dataset.value = option.value;
                tabsContainer.appendChild(tabHeader);
            });
            //create tab filler if the tabs don't go to the end
            var tabHeader = document.createElement('div');
            tabHeader.className = 'tab-end-filler';
            tabsContainer.appendChild(tabHeader);


            // Event listener for tab headers
            tabsContainer.addEventListener('click', function (e) {
                var targetTab = e.target;
                if (targetTab.classList.contains('tab-header-for-select')) {
                    var tabValue = targetTab.dataset.value;
                    var tabHeaders = tabsContainer.querySelectorAll('.tab-header-for-select');
                    var tabContents = tabsContainer.querySelectorAll('.tab-content-for-select');

                    // Toggle active class on clicked tab header
                    tabHeaders.forEach(function (tabHeader) {
                        tabHeader.classList.remove('active-select');
                    });
                    targetTab.classList.add('active-select');

                    // Check the corresponding select option
                    Array.from(selectElement.options).forEach(function (option) {
                        option.selected = (option.value === tabValue);
                    });

                    const ev = document.createEvent('Event');
                    ev.initEvent('change', true, false);
                    selectElement.dispatchEvent(ev);

                    // Hide all tab contents
                    tabContents.forEach(function (tabContent) {
                        tabContent.style.display = 'none';
                    });
                }
            });
        }

        var item = document.getElementById("multiple-list");
        var classListActive = document.querySelectorAll(".tab-header-for-select");
        if (item !== null) {
            classListActive[item.selectedIndex].classList.add('active-select');
        }

        // Number of results functionality
        const pageNumberOSS = document.createElement("div");
        pageNumberOSS.classList.add("page-number-OSS");
        var totalpage = Number(document.getElementsByClassName('active-select')[0].textContent.match(/\(([^)]+)\)/)[1]);
        var currentPageNumber = document.getElementsByClassName("itinerary-list__content__tour-list").length;

        var urlParamsCountry = new URLSearchParams(window.location.search);
        var myParamCountry = urlParamsCountry.get('q');
        var myParamCatagory = urlParamsCountry.get('t') ?? (document.querySelector('.active-select').textContent.replace(/ *\([^)]*\) */g, "").trim().toLocaleLowerCase());
        if (myParamCatagory.slice(-1) === 's') {
            myParamCatagory = myParamCatagory.slice(0, -1);
        }

        let resultsString = totalpage > 1 ? 'results' : 'result';
        pageNumberOSS.innerHTML = `1 - ${currentPageNumber} of ${totalpage} ${myParamCatagory} ${resultsString} for <span style="text-transform: capitalize">"${myParamCountry}"</span>`;
        var child1 = document.querySelector('.itinerary-list__content')
        document.querySelector('.result-page-tab-content').insertBefore(pageNumberOSS, child1);
        var pageNumberOSS1 = pageNumberOSS.cloneNode(true);
        document.querySelector('#result-page-tab1').appendChild(pageNumberOSS1);
        // Number of results functionality

        document.querySelector(".onsite-results-title strong").innerText = `"${myParamCountry}"`;

        if (document.getElementById('tabs-container-for-select').scrollLeft == 0) {
            document.getElementsByClassName('left')[1].style.display = 'none';
        } else {
            document.getElementsByClassName('left')[1].style.display = 'block';
        }
        document.getElementById("tabs-container-for-select").addEventListener("scroll", scrollDetect);

        function scrollDetect() {
            // document.getElementsByClassName('left')[1].style.display = 'block';
            if (document.getElementById('tabs-container-for-select').scrollLeft == 0) {
                document.getElementsByClassName('left')[1].style.display = 'none';
            } else {
                document.getElementsByClassName('left')[1].style.display = 'block';
            }
        }

        // Back To Top functionality
        let backToTopButton = document.getElementById("scroll-to-top");

        const footer = document.querySelector('.sd-footer');
        const offsetFromFooter = 20;

        window.addEventListener('scroll', scrollToTopListPage);
        window.addEventListener('touchmove', scrollToTopListPage);

        backToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        function scrollToTopListPage() {

            if (window.scrollY > 100) {
                backToTopButton.classList.add('show');
            } else {
                backToTopButton.classList.remove('show');
            }

            const footerRect = footer.getBoundingClientRect();
            const buttonRect = backToTopButton.getBoundingClientRect();

            if (footerRect.top < window.innerHeight) {
                const newBottom = (window.innerHeight - footerRect.top) + offsetFromFooter;
                backToTopButton.style.bottom = `${newBottom}px`;
            } else {
                backToTopButton.style.bottom = '70px';
            }
        }
        // Back To Top functionality ends
    }
});

class SearchFilter {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.paginatedContent = paginatedContent;
            this.pagination = document.querySelector('.pager-properties');
            this.el.addEventListener("change", this.getFilterInputValue);
            this.applyFilter = this.applyFilter.bind(this);
            this.url = this.el.getAttribute("data-action");
            this.method = "GET";
            this.itemId = this.el.getAttribute("data-item");
            this.category = null;
            this.filterOptions = null;

            this.pageCounter = 2;

            this.loadMoreButton = document.getElementById("load__more__results");
            this.onsiteFilter = document.querySelector(".on-site-filter");

            this.displayOnsiteFilter = this.displayOnsiteFilter.bind(this);

            var urlParamsCountry = new URLSearchParams(window.location.search);
            var myParamCatagory = urlParamsCountry.get('t');
            this.displayOnsiteFilter(myParamCatagory ?? "");

            this.queryString = new URLSearchParams(window.location.search);
            this.queryStringValue = Object.fromEntries(this.queryString.entries());
            PaginatedData.setURLqueryString(this.queryStringValue.q);

            this.hostPath = window.location.protocol + "//" + window.location.host + window.location.pathname;
            this.regex = /\/$/;

            if (process.env.NODE_ENV === "development") {
                this.url = "/src/api/search-filter-api-response.json";
            }
            this.keywordSearchPage = document.querySelector(".keyword-search-filter > .on-site-filter");

            if (!document.getElementById('load__more__results')) {
                const emptyLoadMore = document.createElement('div');
                emptyLoadMore.innerHTML = `<a class="sd-button--primary load__more__results" href="${this.hostPath}" data-totalpages="1" data-item="{1EE4A9D5-5D53-4B11-8A0E-4935265371D4}" id="load__more__results" data-action="/ajaxroutes/Search/KeywordSearchHtml" style="display:none">Load More</a>`
                document.querySelector('#blog__cards').appendChild(emptyLoadMore);
            }
        } catch (error) {
            console.log(error);
        }
    }

    getFilterInputValue = (e) => {
        let filteredValue = e.target.value;
        let splitValue = filteredValue.split("%");
        this.category = splitValue[1].toLowerCase();

        if (this.queryString.has('page')) {
            this.queryString.delete('page');
        }
        if (this.queryString.has('t')) {
            this.queryString.set('t', this.category);

        } else {
            this.queryString.append('t', this.category);
        }
        this.queryStringValue = Object.fromEntries(this.queryString.entries());
        var url = '?' + this.queryString.toString();

        window.history.pushState({ path: url }, '', url);

        var currentTabFromCategory;

        switch (this.category.toLowerCase()) {
            case "hotels":
                currentTabFromCategory = "properties";
                break;
            case "things to do":
                currentTabFromCategory = "itineraries";
                break;
            case "tours":
                currentTabFromCategory = "experiences";
                break;
            default:
                currentTabFromCategory = this.category.toLowerCase();
                break;
        }

        PaginatedData.setTab(currentTabFromCategory);
        PaginatedData.setSearchflag(true);
        PaginatedData.setFilter(splitValue[0]);
        this.applyFilter();
    }

    async getDataFromAPI(url, method) {
        await HttpClient.AsyncGetRequest(url, method)
            .then(result => {
                let resultData = JSON.parse(result);
                if (resultData.filterOptions)
                    this.filterOptions = JSON.parse(resultData.filterOptions);

                // resets the filter checkboxes to ensure they only match what the current tab contains
                let paginationData = document.querySelector(".onsite-container-local-1 > .sd-pagination-content");
                paginationData.innerHTML = "";
                paginationData.insertAdjacentHTML("beforeend", resultData.result);

                let filterData = document.querySelector(".keyword-search-filter");
                filterData.innerHTML = "";
                filterData.insertAdjacentHTML("beforeend", resultData.filterOptionResult);

                const observer = lozad();
                observer.observe();

                PaginatedData.resetFiltersOnTabChange();

                //Run callback to update the pagination navigation
                if (resultData.filterOptionResult.length > 0) {
                    PaginatedData.UpdateReAttachFilterOptions();
                    PaginatedData.UpdateReAttachMobileFilterOptions();
                }

                this.displayOnsiteFilter(resultData.searchCategory);
            })
            .catch(error => {
                console.error(error)
            });

        if (document.getElementById('load__more__results')) {
            var pos = document.getElementById('load__more__results').href.indexOf('search');
            var str = document.getElementById('load__more__results').href.substring(pos);
            var str1 = window.location.origin + '/' + str;
            document.getElementById('load__more__results').href = str1;
            document.getElementById('load__more__results').removeAttribute("rel");
            document.getElementById('load__more__results').setAttribute("rel", "next");
        }
        // Number of results functionality
        const pageNumberOSS = document.createElement("div");
        pageNumberOSS.classList.add("page-number-OSS");
        var totalpage = Number(document.getElementsByClassName('active-select')[0].textContent.match(/\(([^)]+)\)/)[1]);
        var currentPageNumber = document.getElementsByClassName("itinerary-list__content__tour-list").length;

        var urlParamsCountry = new URLSearchParams(window.location.search);
        var myParamCountry = urlParamsCountry.get('q');
        var myParamCatagory = urlParamsCountry.get('t');
        if (myParamCatagory.slice(-1) === 's') {
            myParamCatagory = myParamCatagory.slice(0, -1);
        }

        let resultsString = totalpage > 1 ? 'results' : 'result';
        pageNumberOSS.innerHTML = `1 - ${currentPageNumber} of ${totalpage} ${myParamCatagory} ${resultsString} for <span style="text-transform: capitalize">"${myParamCountry}"</span>`;
        var child1 = document.querySelector('.itinerary-list__content')
        document.querySelector('.result-page-tab-content').insertBefore(pageNumberOSS, child1);
        var pageNumberOSS1 = pageNumberOSS.cloneNode(true);
        document.querySelector('#result-page-tab1').appendChild(pageNumberOSS1);
        // Number of results functionality

        // Back To Top functionality
        let backToTopButton = document.getElementById("scroll-to-top");

        const footer = document.querySelector('.sd-footer');
        const offsetFromFooter = 20;

        window.addEventListener('scroll', scrollToTopListPage);
        window.addEventListener('touchmove', scrollToTopListPage);

        backToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        function scrollToTopListPage() {
            if (window.scrollY > 100) {
                backToTopButton.classList.add('show');
            } else {
                backToTopButton.classList.remove('show');
            }

            const footerRect = footer.getBoundingClientRect();
            const buttonRect = backToTopButton.getBoundingClientRect();

            if (footerRect.top < window.innerHeight) {
                const newBottom = (window.innerHeight - footerRect.top) + offsetFromFooter;
                backToTopButton.style.bottom = `${newBottom}px`;
            } else {
                backToTopButton.style.bottom = '70px';
            }
        }
        // Back To Top functionality ends

    }

    //displays the onsite search filter depending on the category of search ("Destinations", "Things to Do", "Tours" etc.)
    displayOnsiteFilter(tab) {
        this.onsiteFilter = document.querySelector(".on-site-filter");

        if (tab) {
            PaginatedData.setOnsiteSearchCategory(this.category);
        }
        if (this.onsiteFilter) {
            if (tab === "tours" || tab === "hotels" || tab === "things to do") {
                this.onsiteFilter.style.display = "block";
            } else {
                this.onsiteFilter.style.display = "none";
            }
        }
    }

    async applyFilter() {
        const currentPage = 1;

        const data = {
            pageid: this.itemId,
            page: currentPage,
            filter: PaginatedData.getFilter(),
            isSearchPage: PaginatedData.getSearchflag(),
            q: PaginatedData.getURLqueryString(),
            category: this.category,
            tab: PaginatedData.getTab()
        }

        if (process.env.NODE_ENV === "development") {
            const url = `${this.url}?data=${encodeURI(JSON.stringify(data))}`;
            await this.getDataFromAPI(url, this.method);
        } else {
            const url = `${this.url}?data=${encodeURI(JSON.stringify(data))}`;
            await this.getDataFromAPI(url, this.method);
        }
    }
}


export default SearchFilter